import {
    runAutoScheduler,
    createUpdateDivisionVirtualDraws,
    createUpdatePointerVirtualDraws,
    updatePlanSummary,
    deleteAllVirtualDraws,
    deleteVirtualDraw,
    getDayPlannerData,
    saveDayPlannerDayConfig,
    copyDay,
} from '../api/tmsEventsDayPlannerApi';
import { generateRandomColor, resetColorIndex } from '../utils/courtSchedular';
import { isMatchScheduled, primaryViews } from '../utils/dayPlanner';
import {
    GET_DAY_PLANNER_DATA,
    GET_DAY_PLANNER_DATA_SUCCESS,
    GET_DAY_PLANNER_DATA_FAILURE,
    TOGGLE_DAY_CONFIG_SIDE_PANEL,
    SAVE_DAY_PLANNER_CONFIG,
    SAVE_DAY_PLANNER_CONFIG_SUCCESS,
    SAVE_DAY_PLANNER_CONFIG_CONFIRM_CLEAR,
    SAVE_DAY_PLANNER_CONFIG_FAILURE,
    TOGGLE_ADD_DIVISIONS_SIDE_PANEL,
    CREATE_UPDATE_VIRTUAL_DRAWS,
    CREATE_UPDATE_VIRTUAL_DRAWS_FAILURE,
    CREATE_UPDATE_VIRTUAL_DRAWS_SUCCESS,
    AUTO_SCHEDULE_VIRTUAL_DRAWS,
    AUTO_SCHEDULE_VIRTUAL_DRAWS_FAILURE,
    AUTO_SCHEDULE_VIRTUAL_DRAWS_SUCCESS,
    UPDATE_DAY_PLAN,
    SET_SELECTED_SCHEDULED_VIRTUAL_DRAW,
    SET_PREVIOUS_DAY,
    TOGGLE_SUMMARY_SIDE_PANEL,
    UPDATE_DAY_PLAN_SUMMARY,
    UPDATE_DAY_PLAN_SUMMARY_FAILURE,
    UPDATE_DAY_PLAN_SUMMARY_SUCCESS,
    COPY_DAY_TO_SCHEDULE,
    COPY_DAY_TO_SCHEDULE_FAILURE,
    COPY_DAY_TO_SCHEDULE_SUCCESS,
} from './actionTypes/day-planner-types';
import { showErrorPopup } from './notification-actions';

export const getDayPlannerSpecificData = (eventId, primaryView, day = null, facilityId = null, dateToFetchData = null) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Loading',
    });
    dispatch({
        type: GET_DAY_PLANNER_DATA,
        payload: {
            day,
            facilityId,
        },
    });
    try {
        const response = await getDayPlannerData(mainApi, eventId, primaryView, day, facilityId);
        const { data, status } = response;
        if (status === 204 || status === 205) {
            dispatch({
                type: GET_DAY_PLANNER_DATA_FAILURE,
                payload: {
                    showDayConfigModal: true,
                    viewState: {
                        primaryView,
                        day: dateToFetchData,
                        facilityId,
                    },
                },
            });
        } else if (!data.viewState?.day && dateToFetchData) {
            await dispatch(getDayPlannerSpecificData(eventId, primaryView, dateToFetchData, null, null));
        } else {
            const newViewState = data.viewState;
            if (!data.viewState?.primaryView) {
                newViewState.primaryView = primaryViews.CapacitySimulator;
            }
            const enabledFacilitiesForDay = data.dayConfig.facilities?.filter((facility) => {
                return facility.courts.some((court) => {
                    return court.selected;
                });
            });
            if (!data.viewState?.facilityId) {
                if (facilityId) {
                    newViewState.facilityId = facilityId;
                } else if (enabledFacilitiesForDay.length > 0) {
                    newViewState.facilityId = enabledFacilitiesForDay[0].id;
                    await dispatch(getDayPlannerSpecificData(eventId, primaryView, day, enabledFacilitiesForDay[0].id, null));

                    return;
                }
            }
            dispatch({
                type: GET_DAY_PLANNER_DATA_SUCCESS,
                payload: {
                    eventPlan: data.eventPlan,
                    dayConfig: data.dayConfig,
                    viewState: newViewState,
                    showDayConfigModal: !data.dayConfig,
                    enabledFacilitiesForDay,
                },
            });

            await dispatch(updateDayPlanData(data.dayPlan));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        const showDayConfigModal = error?.response?.data?.MessageStatusCode === 252000;

        dispatch({
            type: GET_DAY_PLANNER_DATA_FAILURE,
            payload: {
                showDayConfigModal,
                viewState: {
                    primaryView,
                    day: dateToFetchData,
                    facilityId,
                },
            },
        });
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const saveDayPlannerDayConfigData = (eventId, primaryView, dayConfigData) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: SAVE_DAY_PLANNER_CONFIG });
    try {
        const response = await saveDayPlannerDayConfig(mainApi, eventId, dayConfigData);
        const { status } = response;
        if (status === 204) {
            dispatch({ type: SAVE_DAY_PLANNER_CONFIG_FAILURE });
        } else {
            dispatch({
                type: SAVE_DAY_PLANNER_CONFIG_SUCCESS,
                payload: {
                    showDayConfigModal: false,
                },
            });

            await dispatch(getDayPlannerSpecificData(eventId, primaryView, dayConfigData.day, null));
        }
    } catch (error) {
        if (error.response.status === 409) {
            // need user to confirm a retry
            dispatch({
                type: SAVE_DAY_PLANNER_CONFIG_CONFIRM_CLEAR,
                payload: {
                    showConfirmClearSchedule: true,
                },
            });
        } else {
            dispatch({
                type: SAVE_DAY_PLANNER_CONFIG_FAILURE,
            });
        }
    }
};

export const toggleDayConfigSidePanel = () => async (dispatch, getState) => {
    const { dayPlanner } = getState();
    dispatch({
        type: TOGGLE_DAY_CONFIG_SIDE_PANEL,
        payload: {
            showDayConfigModal: !dayPlanner.showDayConfigModal,
        },
    });
};

export const toggleSummarySidePanel = () => async (dispatch, getState) => {
    const { dayPlanner } = getState();
    dispatch({
        type: TOGGLE_SUMMARY_SIDE_PANEL,
        payload: {
            showSummarySidePanel: !dayPlanner.showSummarySidePanel,
        },
    });
};

export const toggleAddDivisionsSidePanel = () => async (dispatch, getState) => {
    const { dayPlanner } = getState();
    dispatch({
        type: TOGGLE_ADD_DIVISIONS_SIDE_PANEL,
        payload: {
            showAddDivisionsSidePanel: !dayPlanner.showAddDivisionsSidePanel,
        },
    });
};

export const saveVirtualDraws = (virtualDrawData) => async (dispatch, getState, { mainApi }) => {
    const { dayPlanner } = getState();
    const { viewState, dayConfig } = dayPlanner;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Updating',
    });
    dispatch({
        type: CREATE_UPDATE_VIRTUAL_DRAWS,
    });
    try {
        let createUpdateFunction = null;
        switch (viewState.primaryView) {
            case primaryViews.CapacitySimulator:
                createUpdateFunction = createUpdateDivisionVirtualDraws;
                break;

            case primaryViews.DraftDraws:
                createUpdateFunction = createUpdatePointerVirtualDraws;
                break;

            default:
                dispatch({ type: CREATE_UPDATE_VIRTUAL_DRAWS_FAILURE });
                dispatch({ type: 'SPLASH_HIDE' });
                return;
        }

        const response = await createUpdateFunction(
            mainApi,
            viewState.tmsEventId,
            dayConfig.id,
            viewState.facilityId,
            virtualDrawData,
        );
        if (response?.data.error) {
            dispatch({ type: CREATE_UPDATE_VIRTUAL_DRAWS_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error creating virtual draws',
                error: response?.data?.error,
            }));
        } else {
            dispatch({ type: CREATE_UPDATE_VIRTUAL_DRAWS_SUCCESS });
            dispatch(toggleAddDivisionsSidePanel());
            await dispatch(getDayPlannerSpecificData(
                viewState.tmsEventId,
                viewState.primaryView,
                viewState.day,
                viewState.facilityId,
                null,
            ));
        }
    } catch (error) {
        dispatch({
            type: CREATE_UPDATE_VIRTUAL_DRAWS_FAILURE,
        });
        dispatch(showErrorPopup({
            message: 'Error creating virtual draws',
            error,
        }));
    } finally {
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const updateDayPlannerSummary = (updatedPlanSummary) => async (dispatch, getState, { mainApi }) => {
    const { dayPlanner } = getState();
    const { viewState, dayConfig } = dayPlanner;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Updating',
    });
    dispatch({
        type: UPDATE_DAY_PLAN_SUMMARY,
    });
    try {
        const response = await updatePlanSummary(
            mainApi,
            viewState.tmsEventId,
            viewState.primaryView,
            dayConfig.id,
            viewState.facilityId,
            updatedPlanSummary,
        );
        if (response?.data.error) {
            dispatch({ type: UPDATE_DAY_PLAN_SUMMARY_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error updating summary',
                error: response?.data?.error,
            }));
        } else {
            dispatch({ type: UPDATE_DAY_PLAN_SUMMARY_SUCCESS });
            dispatch(toggleSummarySidePanel());
            await dispatch(getDayPlannerSpecificData(
                viewState.tmsEventId,
                viewState.primaryView,
                viewState.day,
                viewState.facilityId,
                null,
            ));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({
            type: UPDATE_DAY_PLAN_SUMMARY_FAILURE,
        });
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error updating summary',
            error,
        }));
    }
};

export const autoScheduleVirtualDraws = (drawStartMode) => async (dispatch, getState, { mainApi }) => {
    const { dayPlanner } = getState();
    const { viewState, dayConfig } = dayPlanner;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Updating',
    });
    dispatch({
        type: AUTO_SCHEDULE_VIRTUAL_DRAWS,
    });
    try {
        const response = await runAutoScheduler(
            mainApi,
            viewState.tmsEventId,
            viewState.primaryView,
            dayConfig.id,
            viewState.facilityId,
            drawStartMode,
        );
        if (response?.data.error) {
            dispatch({ type: AUTO_SCHEDULE_VIRTUAL_DRAWS_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error scheduling virtual draws',
                error: response?.data?.error,
            }));
        } else {
            dispatch({ type: AUTO_SCHEDULE_VIRTUAL_DRAWS_SUCCESS });
            await dispatch(getDayPlannerSpecificData(
                viewState.tmsEventId,
                viewState.primaryView,
                viewState.day,
                viewState.facilityId,
                null,
            ));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({
            type: AUTO_SCHEDULE_VIRTUAL_DRAWS_FAILURE,
        });
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error scheduling virtual draws',
            error,
        }));
    }
};

export const copyDayToRealSchedule = () => async (dispatch, getState, { mainApi }) => {
    const { dayPlanner } = getState();
    const { viewState, dayConfig } = dayPlanner;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Copying',
    });
    dispatch({
        type: COPY_DAY_TO_SCHEDULE,
    });
    try {
        const response = await copyDay(
            mainApi,
            viewState.tmsEventId,
            dayConfig.id,
        );
        if (response?.data.error) {
            dispatch({ type: COPY_DAY_TO_SCHEDULE_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error updating summary',
                error: response?.data?.error,
            }));
        } else {
            dispatch({ type: COPY_DAY_TO_SCHEDULE_SUCCESS });
            await dispatch(getDayPlannerSpecificData(
                viewState.tmsEventId,
                viewState.primaryView,
                viewState.day,
                viewState.facilityId,
                null,
            ));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({
            type: COPY_DAY_TO_SCHEDULE_FAILURE,
        });
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error copying day to schedule',
            error,
        }));
    }
};

export const updateDayPlanData = (dayPlan) => async (dispatch) => {
    resetColorIndex();
    const { virtualDraws = [], ...others } = dayPlan || {};
    const updatedVirtualDraws = virtualDraws.map((vd) => {
        const virtualDrawGroups = vd?.groups?.map((vdg) => {
            const drawColor = generateRandomColor();
            const matchCountInRounds = vdg.roundSize || [];
            const vdgMatches = vdg?.matches?.map((match) => ({
                ...match,
                drawName: vd.name,
                drawId: vd.id,
                drawEliminationTypeId: vd.tmsTournamentDrawElimTypeId,
                groupName: vdg.name,
                groupId: vdg.id,
                drawCategoryTypeId: vdg.drawCategoryTypeId,
                roundMatchCount: (matchCountInRounds.length >= match.roundNumber) ? matchCountInRounds[match.roundNumber - 1] : 0,
                nextRoundMatchCount: (matchCountInRounds.length >= match.roundNumber + 1) ? matchCountInRounds[match.roundNumber] : 0,
                drawColor,
            }));

            return {
                ...vdg,
                matches: vdgMatches,
                drawColor,
            };
        });

        return {
            ...vd,
            groups: virtualDrawGroups,
        };
    });

    const scheduledVirtualDraws = virtualDraws.filter((vd) => {
        const scheduledGroups = vd.groups.filter((vdg) => {
            const scheduleMatches = vdg.matches.filter((vdgMatch) => isMatchScheduled(vdgMatch));
            return scheduleMatches.length > 0;
        });

        return scheduledGroups.length > 0;
    });

    dispatch({
        type: UPDATE_DAY_PLAN,
        payload: {
            dayPlan: {
                ...others,
                virtualDraws: updatedVirtualDraws,
            },
            scheduledVirtualDraws,
        },
    });
};

export const updateSelectedScheduledVirtualDraw = (virtualDrawId) => async (dispatch) => {
    dispatch({
        type: SET_SELECTED_SCHEDULED_VIRTUAL_DRAW,
        payload: {
            selectedScheduledVirtualDraw: virtualDrawId,
        },
    });
};

export const clearAllVirtualDrawsForPlan = () => async (dispatch, getState, { mainApi }) => {
    const { dayPlanner } = getState();
    const { viewState, dayConfig } = dayPlanner;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Updating',
    });
    try {
        const response = await deleteAllVirtualDraws(
            mainApi,
            viewState.tmsEventId,
            viewState.primaryView,
            dayConfig.id,
            viewState.facilityId,
        );
        if (response?.data.error) {
            dispatch(showErrorPopup({
                message: 'Error deleting virtual draws',
                error: response?.data?.error,
            }));
        } else {
            await dispatch(getDayPlannerSpecificData(
                viewState.tmsEventId,
                viewState.primaryView,
                viewState.day,
                viewState.facilityId,
                null,
            ));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error deleting virtual draws',
            error,
        }));
    }
};

export const clearVirtualDraw = (virtualDrawId) => async (dispatch, getState, { mainApi }) => {
    const { dayPlanner } = getState();
    const { viewState } = dayPlanner;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Updating',
    });
    try {
        const response = await deleteVirtualDraw(
            mainApi,
            viewState.tmsEventId,
            virtualDrawId,
        );
        if (response?.data.error) {
            dispatch(showErrorPopup({
                message: 'Error deleting virtual draw',
                error: response?.data?.error,
            }));
        } else {
            await dispatch(getDayPlannerSpecificData(
                viewState.tmsEventId,
                viewState.primaryView,
                viewState.day,
                viewState.facilityId,
                null,
            ));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Error deleting virtual draw',
            error,
        }));
    }
};

export const setPreviousDay = (previousDay) => async (dispatch) => {
    dispatch({
        type: SET_PREVIOUS_DAY,
        payload: {
            previousDay,
        },
    });
};
